import { useState, useEffect } from "react";
import { useAppDispatch } from "./useAppDispatch";
import { refreshAccess, resetAuth } from "../features/auth/authSlice";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";

import { isDemoMode } from "../app/demoMode";

export const useAuthStatus = (shouldRefresh = true) => {
  const [checkingStatus, setCheckingStatus] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const dispatch = useAppDispatch();
  const accessToken = localStorage.getItem("daex-auth-token");
  const { isAuthorized } = useSelector((state: RootState) => state.auth);

  const checkAuthStatus = async () => {
    setCheckingStatus(true);

    try {
      if (isDemoMode()) {
        setLoggedIn(true);
        return;
      }
      if (accessToken) {
        setLoggedIn(true);
      } else if (shouldRefresh) {
        const response = await dispatch(refreshAccess()).unwrap();
        setLoggedIn(!!response);
      }
    } catch {
      setLoggedIn(false);
    } finally {
      setCheckingStatus(false);
    }
  };

  useEffect(() => {
    checkAuthStatus();
  }, [accessToken]);

  useEffect(() => {
    // Im Demo-Modus nie zurücksetzen — ein 403 von einem bewusst gesperrten
    // Endpoint (z.B. organizations) darf die Demo nicht wie einen echten
    // Auth-Fehler behandeln und rauswerfen.
    if (isDemoMode()) return;

    // A failed request (offline, CORS, server down) is no logout: an invalid
    // session is logged out by errorParser (403) or the refresh (401). Treating
    // it as one sent the app back and forth between /login and / forever.
    if (!checkingStatus && !loggedIn) {
      setLoggedIn(false);
      dispatch(resetAuth());
    }
  }, [checkingStatus, isAuthorized]);

  return { loggedIn, checkingStatus, isAuthorized, checkAuthStatus };
};
